<mat-toolbar class="content-header">
    <span class="content-header-full-title">{{title}}</span>
    <span class="content-header-spacer"></span>
    <mat-icon class="content-header-icon"
        *ngIf="canClose"
        mat-button (click)="closed.emit()"
        matTooltip="Close">close</mat-icon>
</mat-toolbar>